import create from 'zustand';

import { View as viewContext } from '@twintag/twintag-core';
import { View } from '@esoptra/zaza-sdk';

import apiHelper from '../services/ApiService';

interface Store {
    data: any;
    dataInAllLanguages: any;

    isLoaded: boolean;
    hasError: boolean;

    getDetails: (language: string) => void;
    getFileURL: (name: string, $qid: string, FileQid: string) => any;
    transformData: (data: any, language: string) => void;
}

const useStore = create<Store>((set, get) => ({
    data: {},
    dataInAllLanguages: null,

    isLoaded: false,
    hasError: false,

    getDetails: async (language: string) => {
        const bodyObj = {
            action: 'getData',
        };

        try {
            const __data = await apiHelper.ExecuteEpsilon(bodyObj);
            set({ dataInAllLanguages: __data });
            set(() => get().transformData(__data, language));
            set({ isLoaded: true });
        } catch (error) {
            set({ isLoaded: true });
            set({ hasError: true });
        }
    },

    getFileURL: async (name: string, $qid: string, FileQid: string) => {
        if ($qid && FileQid) {
            let view = new View(viewContext.getId());
            const sdObj = await view.object(name);
            const file: any = await sdObj.getFile($qid as string, FileQid);
            return file.fileURL;
        }
    },

    transformData: (data: any, language: string) => {
        if (data) {
            data = JSON.parse(JSON.stringify(data));
            if (language === 'en') {
                set({ data: data });
                return;
            }
            for (const key in data) {
                if (Array.isArray(data[key])) {
                    const arr = [];
                    for (const arrObj of data[key]) {
                        let tempData: any = {};
                        if (typeof arrObj === 'object')
                            for (const obj in arrObj) {
                                const name = obj.split('$' + language)[0];
                                tempData[name] = arrObj[obj] || arrObj[name];
                            }
                        else tempData = arrObj;
                        arr.push(tempData);
                    }
                    data[key] = arr;
                } else {
                    const tempData: any = {};
                    if (typeof data[key] === 'object') {
                        for (const obj in data[key]) {
                            const name = obj.split('$' + language)[0];
                            tempData[name] = data[key][obj] || data[key][name];
                        }
                        data[key] = tempData;
                    }
                }
            }
            set({ data: data });
        }
    },
}));

export default useStore;
